


















































import Vue from "vue";
import Component from "vue-class-component";
import { ReportDetail_report_attachments } from "@/models/queries/types/ReportDetail";
import { Fragment } from "vue-fragment";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
@Component({
  props: {
    attachment: Object,
    deletingAttachments: Array,
    report: Object,
    showDeleteConfirmation: Function,
    canDelete: Boolean,
    openImage: Function
  },
  components: {
    Fragment,
    ClipLoader
  }
})
export default class AttachmentCard extends Vue {
  public mounted() {
    console.log(this.$props.attachment);
  }
}
